import { useViewport } from 'contexts/viewport';
import { PageContext } from 'pages/InstructorFormativeSubmissions/PageProvider';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import {
    Button,
    Checkbox,
    Divider,
    Drawer,
    IconButton,
    ScrollableTableMobileSortFilters,
    Stack,
    styled,
    Text,
} from 'shell/components';

const FilterDrawer = ({ columns, sortState, handleSetSortState }) => {
    const { t } = useTranslation();
    const { device } = useViewport();

    const { filters, setFilters, resetFilters } = useContext(PageContext);

    const onClose = () => {
        setFilters((current) => ({ ...current, open: false }));
    };

    const toggleStatus = (status) => {
        setFilters((current) => ({
            ...current,
            status: current.status.includes(status)
                ? current.status.filter((s) => s !== status)
                : [...current.status, status],
        }));
    };

    return (
        <Drawer
            anchor={'left'}
            device={device === 'desktop' ? 'tablet' : device}
            offsetForSidebar
            open={filters.open}
            onClose={onClose}
        >
            <Stack spacing={3}>
                <IconButton
                    sx={{ alignSelf: 'flex-end' }}
                    aria-label={'close'}
                    kind={'exit'}
                    size={'medium'}
                    variant={'square'}
                    onClick={onClose}
                />

                <Stack alignItems={'center'} direction={'row'} justifyContent={'space-between'}>
                    <Text component={'h1'} variant={'h6'} weight={'semibold'}>
                        {t('controls.sort-by', 'Sort By')}
                    </Text>
                    <Button variant={'borderless'} onClick={resetFilters}>
                        {t('controls.reset-all', 'Reset All')}
                    </Button>
                </Stack>
                <ScrollableTableMobileSortFilters
                    columns={columns}
                    sortState={sortState}
                    handleSetSortState={handleSetSortState}
                />
                <Divider />
                <Text component={'h1'} variant={'h6'} weight={'semibold'}>
                    {t('controls.filters', 'Filters')}
                </Text>
                <Stack spacing={2}>
                    <Text color={'light'} variant={'p1'} weight={'semibold'}>
                        {t('table.status', 'Status')}
                    </Text>
                    <CustomStack>
                        <CustomCheckbox
                            checked={filters.status.includes('draft')}
                            label={t('ui.draft-submitted', 'Draft Submitted')}
                            labelPlacement={'start'}
                            onChange={() => toggleStatus('draft')}
                        />
                        <CustomCheckbox
                            checked={filters.status.includes('no-draft')}
                            label={t('ui.no-draft-submitted', 'No Draft Submitted')}
                            labelPlacement={'start'}
                            onChange={() => toggleStatus('no-draft')}
                        />
                    </CustomStack>
                </Stack>
            </Stack>
        </Drawer>
    );
};

const CustomStack = styled(Stack)(({ theme }) => ({
    paddingLeft: theme.spacing(4),
}));

const CustomCheckbox = styled(Checkbox)(({ theme }) => ({
    justifyContent: 'space-between',
    '& > .MuiTypography-root': {
        color: theme.palette.ensightful.neutral[700],
    },
}));

export default FilterDrawer;
